import {
  getGridStringOperators,
  getGridNumericOperators,
  getGridSingleSelectOperators,
} from "@mui/x-data-grid";

const stringCustomOperators = getGridStringOperators().filter((operator) =>
  [
    "contains",
    "doesNotContain",
    "equals",
    "doesNotEqual",
    "startsWith",
    "endsWith",
    "isEmpty",
    "isNotEmpty",
  ]?.includes(operator.value)
);

const numberCustomOperators = getGridNumericOperators().filter((operator) =>
  ["=", "!=", ">", ">=", "<", "<=", "isEmpty", "isNotEmpty"]?.includes(
    operator.value
  )
);

// For id-backed select columns (e.g. Region, Country). The string operators' default "contains"
// can never match a numeric id on the backend, so these columns only offer exact matches.
// "isAnyOf" is renamed to "isanyof" so the filter panel shows its multi-select editor.
const SELECT_OPERATOR_LABELS = { is: "is", not: "is not", isAnyOf: "is any of" };
const selectCustomOperators = getGridSingleSelectOperators()
  .filter((operator) => operator.value in SELECT_OPERATOR_LABELS)
  .map((operator) => ({
    ...operator,
    label: SELECT_OPERATOR_LABELS[operator.value],
    value: operator.value === "isAnyOf" ? "isanyof" : operator.value,
  }));

export { stringCustomOperators, numberCustomOperators, selectCustomOperators };